import axios from '@/resources/libs/axios'

export default {
    list(data) {
        return axios.get(`/vhe/auxiliaries/levels/level2/list/all`, { params: data })
    },
    search(data) {
        return axios.get(`/vhe/auxiliaries/levels/level2/list`,{ params: data })
    },
    find(data) {
        return axios.get(`/vhe/auxiliaries/levels/level2/find/${data.id}`,{ params: data })
    },
    create(data) {
        return axios.post(`/vhe/auxiliaries/levels/level2/create`,  data)
    },
    update(data) {
        return axios.post(`/vhe/auxiliaries/levels/level2/update`,  data)
    },
    delete(id) {
        return axios.delete(`/vhe/auxiliaries/levels/level2/delete/${id}`)
    },
}